import { Button as WDSButton, ButtonProps as WDSButtonProps } from "@datamole/wds-component-button";

type Props = {
    startIcon?: React.ReactNode;
    endIcon?: React.ReactNode;
} & WDSButtonProps;

const Button = (props: Props) => {
    const { children, startIcon, endIcon, ...otherProps } = props;

    return (
        <WDSButton {...otherProps}>
            {startIcon && <WDSButton.Icon>{startIcon}</WDSButton.Icon>}
            {children && <WDSButton.Content>{children}</WDSButton.Content>}
            {endIcon && <WDSButton.Icon>{endIcon}</WDSButton.Icon>}
        </WDSButton>
    );
};

export { Button };
export type { Props as ButtonProps };
